import { useCallback, useEffect, useId, useRef, useState } from "react";

import * as analytics from "@utils/analytics";

import "./SophiaPortfolioStorefront.css";

// ----------------------------------------------------------------------------
// Content
// ----------------------------------------------------------------------------

// Avatar kept as the original inline data URI. You could swap this for an image
// import instead, e.g. `import AVATAR_SRC from "./sophia.jpg";`
const AVATAR_SRC =
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBAUEBAYFBQUGBgYHCQ4JCQgICRINDQoOFRIWFhUSFBQXGiEcFxgfGRQUHScdHyIjJSUlFhwpLCgkKyEkJST/2wBDAQYGBgkICREJCREkGBQYJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCT/wAARCADwAPADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDgwM80uO1AFLjHevKPshRThTRTh0oGFNNO69qQj2piYw800ipNpo2VaIZBtOcYpQlTCPk04RAdqdyLEAU8VIqepqYR8DinCPnOBRzDUSIJz608LgdOalCUuz8anmKUSMA+1KB+dP25pNpzT5kHKM25NIRUgGB0pCOKOZE2ZERwOKQjkVLtOaQrk0rg4kZUZpNual2+tAXjpVXFykJSmFKs7aYRRcGmV2X0qNlIqw64FRMpNVczdyFhxUTdanbJGKhcYq0YTK7Co2qZgaiYGtUck0bPUdaUUf1o21557oop2eKTAxTgPegAHFGMUoHPWlHNAWE25p2wYpQDSgetO4rCBfWnBaAOacKVx8ogWnAUClFJspIXANJj3pelGR6igBccUwg5p4YHuKbuBPB46ZouAYxTSBUmRj3ppxmmKw0jmkxzT8UmOaEKxHtop+Pxo+lVcVhh4phHHvUp5ph9qLiaIWqIipX4qM81ojFkL4BqB6sPioHGa1ic1QhY5qFqlYc1GwrRHHM2QadTcYpwGRXnnugKcMdqaBmnigYopR1pO9OGOuaAFpRzSDr0pR1oGOFLSd6UUDF7ClyBSEhRk4rH1TxFBZgpH+8lHbsDQk2TKajq2as00cEbSSyKigZJJwBXN3fjOG3ZljgM2P487R+tYl7fXWoyZmmH0PCrVN7dCQEbzXJPI5raFNdTz62Ll9gtXnjO5uX2ROLcE4OwZ/Ws5dev7dmeG6c5POCf5VnPbN57LtOQelXbbSpN8W8EK/B9q6eSKRwPE1ZPcuW/jLVF+Uzs/PcZrcsPHDvIq3MSYPVhxisE6QYzzldwz07URWkI+WMbiOpJqXTgy4YqrF6s9Fs9Ttr8ZikyRVoda8+tTNZvvhfYR+R+orqdH1+O8YW8+Enx+DfSsJ03HVHo0cXGpo9Ga5pKdjvSEVkdQ001vSnkCmsOKZLIH5qJgAamYYFRtVoxkV39ccVC1TuKiatonNNEDY+tRNUz1C2M1qjjmbIp3FJSgZOK8890BTs0mKcOeKBoXilHI6Ui04UDQcU7vSUopALnHWmtKF4psr7Qax9T1AwxHafmPT2q4xuY1aqghmu635MZihILtx16VzM7OgJc5dhzmn3MpLhv4/U1TmkZjnaOelbxjY8yrVcndjUV5iO656CrsmyKERgbGHJ//XUMKk4w2PoKtrazSAEEcdiOtUmr6mfLJrQq20MMlzuZgGJGAe9aaWk9wSkIKhCe1Mt9PlSQAhcHqDXpfhXwVPeQCUxBUYD1GawxFdQVzqwmEdR2Z5VLHO8ImllIRRsX3wT/AI1TVhHyp69mHBr2/VvhfHNb7I1wyg49u9eZ694MutHdyykop5OOlRSxlObtc2rZZVguZK6M22cTKNoC8dR0H+FPaJvl/hYH5XHb3plrHLAd6cgdVq7JFvCzxjC9SvQg/SuyMrnmypuOpt6Nq7XGILjAmA6jow9a2OvSuKjZoZUeNjxyv+FdfZT+fEG/SuepGzPUwtbnVnuS0xqk4zTHrNHS0QuKiYdambNRNVoxkQP0qF6ncVA9bROWZC9RNg1K/U8VC9ao5Jmx9acOKb2pRXAe4PHSlHNNHSnDpQAopw4pop3akMUD2p2OKaKdikBVu2Kg1yt/cGW5KDovr6102pSCOF2J6DJrlbaLzpHc4wRyfQk10w0iebitZJFc25ceYQPY1WMZ3kZxjqx9fQVrXLgJu4VFHAp/h/STqOoKZMGKMB2B/iJ6Ck58sXJkU6PtJqEepseFPBNxrTK6xsIxglm4z9K9P0z4YWuxRKoxjt1P41r+FrOOK2iijXAAG44xzXaxxxogx+deDUxVSpJ62R9HKlTw0VFK7OWsvh1oluM/ZFdvVhmujt9LitohHGgVQOAB0q9BtLACrvlKACQKqEXPc46mIadjHbTvMGcZrk/FXhqO4jZwgJIwRjrXomEAwMVmanbrKhBAINOdFJXW5ph8VLms9j5f13QpNK1A7UwrHj39qpxQnYccHoRXqPxB0RfIklVeU+Ye1eaQSpHO33WGcFR3HpXo4Os5x13OPMcPGE7rZlGSHy2yOVNaei3zKDHJkMvB9x2qG8hxKWQ8HkehqvZtsl6ZcDBx/Evb8q7pK6PMpzcJXR0hvo/oe9NN4nrWO5+bqaZk+tNUEXLGyNg3iHvmo2uk9qyyT60mT61SoozeMkzQadeuetRNKDVTNCnkVSppEOu2WHNQt71MelRP1poUzX6c0fyo7UhIFeee6PFOHPSoTMo7037So707MhzSLOaUGqhu1HQ0q3imjkYvbRLnbFB4FVxcgmpDICvJpWLU09jE8RXZjhEY6uefpWSsggtgg+8xLH/Cn67OZrzYuflxn+lVJmB8sDPQk1104aI8XEVXzuwlzMTbKP7zdvTOBWn4b1CRL+RU5y4A/Cs+82pEmAMKFOf1q94LUC8hbyzI5O7aoyWorxXs2LBzk66sz37wvFOlojscM+GbNddGrlBk4rziy1nUYoBLDaG4bsingf41di8Za7a5a70mQwjr5akla8WGGvqfRVsVrZnoNnG8ku0ZrVaCXb7VyGh+K4L4Boi6MP4WGDXSf2rKYN+c/hXVThGKszkqylJ3jsWFiI4JqlqEsMClDKm7GcFq5fWtX12/lMFhshjOQ0jDmsy28LNKxk1DVppgfvqxwCf8Kvlg1qYuU0/dK/ip0u4ZFTIYA4yPvV4hqMD2uoPgYXcR7V75qvhSzuLctHK7MowGV8gD8K8w8TeGpbWUhi0in5gSOf8AOKdJxhK8R1OerDlkcwXJiHJBHQn1qhIxjZJsgqDhh6ZrQ2HyJU/jj7DviqckaAsHyVYcj2PevQ0Z5Erp2Le9XIYccU3Paq1sxwIm5kX5T9R3q15bnkqapNEtNiUtJg9KXaTziqJCgH5qCD3GKACSMUDLDdKiY8d6kPSomqEbzNVpNoqpcXe3uKZc3GM81lyymRjzXPTpX1O3E4rl0RZku2J4NR/aXPeq4pa6VBI8yVaT1uTecxzzSiZh3qHNKDVcqJ533LSXTCp1vfkOTyeBWdu460x2KgnPNRKmmawryiUbiZXv2duBkk/QdKHU5GOyAfrmq8aHzxu54xz9auBgSx4AHJ/AUJWMZu7uxlx90oTxtH512Hw1s1jkNyw+ZVAFcdcShix9xjFev/DHR4ptIDOiksoHNc+MdqdjuyqN61+xaXxtKly+n6RYxXEqKzySSttjQAZPTqfaoPC/xU1jXLk239kWE+1XkKQTNv2L1OCMfTJrtLXwtaxRlI7aFSxyQ68Grlh4MtLNneKw0+AuMM0aHJFcVGVO2sT1MTSqN3jL8Clpd5aaosd9aRbFfIb5cEHuD712VjDvswpOcetYz2sdpF5UUaqCeiqBz+FbOnTgRYJ9qyU/fZo4fuzD8R291BbSNaxl3C5AHc15NrPgjxHq+tRXUMn2hGhAdLuUhIpO5ABwa95aHzSxYbkIxgiqEuh6er70tkUnnjIFaU6jjqjGdGNTSRxsHg6+s5I7jTrsWwEao1qCZIiQOW55BPtxS+INIMtgfMA8xVOTjvXoMFokMQwqgdsVma5aq0bHAwRgj+tOV27sqnBR0ifNusL9j1TgDbIuazpSNpOdwU4Jx/Ca1fHoFnqsMeP4mH4VhRTAMYiRtdCK9ClrFHk4pWqNAXMN1HIec/Ifcjofyrq1ihaJWwBuGa5IDzLZt33guR9V/wDrVvW0zT2ERRskLg+xpVFsaYSS1VrjLtEV+MVNbxIyDIFZ8wcN82Sav6fnZzVSVo7k05KVR3QTwKIzioIoxsyRzV2QAgg1V6fKKUJNqxpUgua5G9QNUz9ahatUc0ytczFjiq+c0jtub1pBzVRVkc1SfNK44GnZplOByKogWlpoNLnigBT0pkpymfSnZ6VBcOEhdvQUhogIKtkHHPWqom5kzkBQf6VOrecm5ew/pVRnHkTEg5YGpiE2KZ/MtlcfeXqfWvffhe23QrZiQNyivnSOQiBhn+LBFe4fDDVv+JFbKW+6Nv5VyZgvcR6+RtOrJPsezRcquB2q3nauWIAFczBrC+WBvA9Oao6x4ikELiMktjgA1w0o6HsV9NDb1DUEUMIwG/2vSrOmGVkGFOGGcYrhm1PVLCw3ixF1JIoJGehp+j+NNXVwk9nPGx+UbRkAfWsUuaV0PlcYW6non2140aNVIYDPI4qrZa7a3cpjl/dyKcMh6isKC/8AEV3c5MlqLVuzA7wPr61S8T6Vdwuup2LMJYxyB/EPQ1vG+xzuy1Z6Ms0BQhWBrN1Yq0bYIOBXFaF4sW7QK7bZV4ZT61uy3xni2g5yKuUhwppO6Z4H8WI2bXIvLHIJNcakwddynDI2RXYfFzVI9P1oRmPzJXUleenNef6fOWuJlJwQdw+ua9CgvcR4WMkvbM3LaQEE4yDwR9au2N8bdmiOMDkVkvIFk3DoRUxlBmUj+JR19au19zOMnHVGtLP5pBFSxXflrjFUUbNP5NXyq1iPayTuXDek0xp8896rUZo5EN1pPcmM2c0wvmmA0ZFOxDm2USaAcU3OaUdKoyHA0oNNHWlzSAdmlFNFGaYxSaqag222f0qyTxVPUQXtioqWNEFo4+xnAyxdqhdfkZRkjFJZyERlOMg5p00nkmJx90qN1CRMjNlzGXHqQ1enfC64aXT5YwfuPkfjXnt7brgMpyG+UfzFdL8KtVW11KWykbb5g4z9awxceamztyqpyYhX6nr2bqOM9SMdqXTbqJZC90enIU9q1tMCSghiOmKyPEnhaLXbZ49zxFTkOhxXkKWlm7H0tVNz2ubLeJtHjXE1xGGx0HNMg8U6TIuxCwyeu3imeE49H02wgtNQ0y0kmh2r5vlg7sZ5J9fau907U/DNvpyxJp1sCsm8L5Q4JOciqp0oJ7kValWK/hs5SDxjZQuY/s125GM4iPfpUl7490m2j/0wTWyMSo86FgCfTpXbXfivS8l4LcF2CgkJycHjtXFeI7AeL9etrmdm+yWqt5cDLgEk5LMP5VtKnBa3OZSqy3p29TmL6wivNSt9Q03MQlYblxgEetdjEqxR8jlV5qk1isF+DtGxRx7VW8T+ILfw/otzfXDhVjQn6nsKyveyRpB8qbZ8+fF6/W88azIpyIIwp+p5rnbHmXeoxmMN/IVU1K+m1O/nvJiTLO5dvqTVuwIUgHoPl/A17UI8sEj5arU56rl3NTP977uePxpjylJUGfutRICtsHHYj9Kq3DnzAQeppGkWdBAd6bh35qfNUtNfdb/jVurRLHZ/Oim5ozTELmjNJmjOaAKINLmmZpc0EDxSg0zNKDQND6O1NzR2oADyetMmXcCO1PJFMfgcUhoyZOJsovQ8gU64UTKEB6DiqN7O0V1uQkNQb3cuejAfnSWwpO71JBJvtjG/DLwfYiq1tey2F7FeQHEiNnGev/66a04fPYnv61EvX5gD61TV0Qm07o9/8HeLYdVtIZkcHoHXPKn0NdxG4kBVSPm5Br5h8LapdaVqAltnJVuWj7NivZPDXja3ukTc+AOCG6ofQ14eLwzg/d2Pq8BjI14py3OtuLC7Ry9qxRumOx9jUtpPr8ICJZwtj+JgD/StCz1SC4VGDJ/tE9/Stm1vIACzSLjtisqE2jvqVJpWTMuC21i9wLo+SnUpH0rcs9PW2jAAwP51NHqEG3qP8ax9d8WWunxFRIpc9FBrSbb3OWU5S3JNWaGEMWYDjLH0FfOPxX8bN4j1JtLs2P2G1bkg/wCtf/AV3ni3xbcT6fcOjsqMp5P8X/1q8NhUzzM55LMSTXVg6V3zs8nMq7jFU49dyosREqjvVm34mVexNI67XZscg0kDFZkJ65zXpnhG6dv2cof4s/qKpNA0sG7aeDirygSoPdcZ96fYqfNZGHDDv61mzqjqN0pmRGDZx6+9aW6q0kCwOdgOCOPrUiZ2jNVHYJ7k2c0U3OaXNURcXNFJSUBcz8kU4Go8+9OzQSPBpc0ylzQA8GlzTKXPFACnkimSNhHPoKdmobltsL0mNbmG0X2iZnY8Zxn2qrKuGIUcVp8RRkE/U+9UmGdzY4FSnqDVkVG44pC2B9etK+STURNaIxbNzw00f9p2qyEYZwp/EGuomsGhnM9sxU56D0rgraZoZkdTyrA16r4cVtUjRkXcHGRXLXjZ8x34Sd48i3F03WNXtod0GWUHkdcVc/4TjWB8hAT65resNAlswWVCQxyQRWnb6CZiCbZWHuK87nipbHt2nKG5zln4r1y7/do7Nnj5VNbWneHr3UCZrstg8kE5JrpNP0EW+MwKo+lbF1GlvZu2AoUZ+tROd3ogi2keOfEcraWDW8fGV5PtXl9kMSAenX8q774m3JEmx2yz/M3+Fee2soSTnv616mGjaB4WLlzVNR7Ll2C9cZNQEbZV/DNWjhJhkcMMVDcf6wMOhGK6kcTNjTM3EUiD745FTwbRICc5DdfTNY+m3bWtzHIDxnaa2ZiBOSOknIqJI3pyNB8MMEdODUP3TjuKakuUB796aXIPJzmlE1qLS5ID7U7NRBqduqzEdmkzSZoNMDPzTqYDSg0iR4IpRimU4UAPBoqazsbi+k2QIWPc9hXVab4DaVQ9y7N7LwKwq4mnT0k9Ttw+BrV1eK07s4/k1WvHCwt78V1HijRIdGniSFdpdSTz17VympKypEoP3nwTVQqe0jzIxq0vZVHTe6M/ZvGXyEHQetVpnDcAYAqW6mG4oDhF6mqLyluBwPetEjnnK41gCTTdoxS+1BHFURYRR83Fen/DLUo4pxEWHzdQT3rzKPrW/oEksE4mtyRLGQcf3hWNePNGx04SfJO59O2scc8YxwcdxVuK28vgFD+Fcr4N1ZdQsYp4pGbI5Ru1dpA4ZM9Qe9eG4tOx9JGd46EsYRVH6kCsvxBPttn5woGdprSdxHznnsK4bx5rH2TT55GbGBWsI3ZzVJWTPFviHqovNZdEJKpxXIq5DA1PqFy11eSTNyXYmoAMivahHlikfP1Zc0my8j+dDycstLKQ0WR1FVIXKE+38qsDow7EZFWZjFYgj862IpjLbRsTyhrIX+lW7WQhGWlI0hua0EgJK9jTx0+lVIHxIPQjirI5Yk96z6nTurEqvTge9Qg4NPBrS5lYlo6U0GnZ4oEzNFKDTAaXNBA/NXNMsJNRuVhQHH8RHYVQDZNeleBdBMdqs8i/PJhj/SuXF1/ZQut2ejlmE+sVbS2W5q+HvD8VpEo2AY9q6qO1jROnaltbUIBgVYcbUJrwYJyd5H1VVpR5Y7HlvxGx/aMQOMiP+tcDq7AIpXqpzXcfEOYSaxgfwxgV51q053sM+1fRUI2pRR8Zi5XxEmZMrZOOT6/Wojkc8CnE5OTTeprY4mwUUp4z+mKAMUHk0DETtW54fultr+EvjY2FbPTBrEAyauQA+XuXqpzUyV0a03Znt/g6H7JdXMNvM6Iu2RQoBHPXr7ivR7TzyoKzRlcA8rz/ADry34bawNQnnk2nC20cZP8AtDNd1De+RlgSB6V5daGuu57dGemmx0F842s4lEcQHQ8sfxrxL4t6ykrGGHMZAUNGGJH1OfX0r0PWtaCQblJ5GRz1NeFeNNR+2Xsg3liDyfU96eGjeYYpKNNu5yzHLUq8jFN75p468V6x8+OQY/lU0bcAelRKMfjT8Ed6BolUdu4qSEkHNRKfmzUqdKllxLsbYAOelX1O5QazYFytallEZjgDvxUbHTBCiJiM4NLgjrXZaJ4Va7VWfAB9a6UfD2zni+ePJPccGueeLjB2Z2RwUqiujymlJPFdlrXw2vLUNLYuJVHPlvw34HvXITQy28hilRkcdVYYNb0q8Ki91nJWw9Sl8aMoGk3U3dSZ5rY5LmloVidQ1KCIjK53N9BXt2jwrBAigYwBXm3gHTjzcsv3jx9BXp1rlUHavn8wq81Sy6H2eT4b2WH5nvLU1ImG2q9xLhSD0pPN2ryaz7+52p1rnpa7nRX0Vzy7xpcb9XuMdsCuA1Ft0zHPArrvEU3m6jcMe7GuMnyzNnua+jpv3Uj4quvfkyuAD9KaOtP20mAK1OUaDk80elOYYxQDwKBgoNW7Jsb/AMxVYVYtflOQeTkY9sVLNI7nZ/DnUGstQ+zMSguOVOcYPb8+a9ZcsIepZiOO2a8U0i3dbi3ZcqflCt716nNqoXTo5mJ3GPcwzzmuGtvc9TD/AA2Of8TayYQ0Kudy8Z9PU15dqM/2m4LdB2HtXR+Irl2iMzbh5xOfp6Vysh3HPtW9KCWphiaja5WQYwcU9eDSYzzin8dB2roPPsKDk5/GpOuCKjA5qSP+VA0P6LjvUsXQZqMDJqWMc/Sky0XIF+YYro9BhDTrngZrnrc55711GhAK6n8aznsdVLex6n4ciUqoxXbWtqpQcVxHhuZQF5rvrGQMgryK+57lFWiQXOnq6/drk/Evgmz1iIiWPbIPuyLwy16EVDLVea3VsgjNcusXzRep0KSa5Zao+Owakt4XuZ0iXq5wKizXQ+DbD7ReG4YZCcD619FWqckHI+YwmHderGmeg+HLEWdrGijgACukjk2gDFZVkAiCrvnYPWvmpattn3askoonuLjArG1K6O3rU9xcZJrB1a8CxOfQVpSjdnJiJKxwGsy7riVvUmuamXBPvW3qcu5ifc1jyjca9+loj4/EfEVsZOKawyaey4NJjvW1zksMxnimkYNPPc0nXFAcoL97mrun25urqCFc/MwBI9KqKuau6fO9lcxzxkBlOaGrocXZ6noF5pyWk9tDEAp3KRjrjrW3cxFtNiibhXGT7/5zXIxeIRqN6rzQuNgCkRngfnXRaz4nsHsEihS4Eirhdy9wPrXHKlN9D0qeIprqcf4rIeWG1XgRZBx65rm7qPyyBjt2rUvr9JZy7I7EkEk/WqWpzpLKCiFRgVtTi1oY1pxk7plBFOOlKV2mpYsKTuPyHofSmFcnArVM5Wh3G0UL97PY0Y+Td3pQeKYiVKlQYOKij449qlQnOalmiLlrwwBrp9HbaRkVy8LfOM10WmOBg5rGbOugekaDc7SvOK7zTbzKDmvLdIutuK7DT7/AAzXnVonr0p6HdRXIPfNTeaGHpXNQajkDkVdhvwTjNczRq2f/2Q==";

const UPDATED = "Updated 24 Sep 2026 · for first-time investors in the UK";

const LIVE = {
  full: "Thursday 2 Oct, 7:00pm (UK)",
  medium: "Thursday 2 Oct, 7pm",
  short: "Thu 2 Oct, 7pm",
};

const SLICES = [
  {
    id: "sp500", color: "var(--sp-s1)", role: "The engine", name: "S&P 500",
    fund: "Vanguard S&P 500 UCITS ETF (Acc)", ticker: "VUAG", pct: 20,
    why: [
      "The 500 biggest companies in the US. It's a bit less concentrated than the Nasdaq 100, which is the 100 biggest tech companies.",
      "The S&P 500 also holds sectors outside tech, like healthcare, financials and energy. This is the driver of my portfolio.",
    ],
  },
  {
    id: "global", color: "var(--sp-s2)", role: "Spread beyond the US", name: "Developed Asia or All-World",
    fund: "Vanguard FTSE Dev. Asia Pacific ex Japan", ticker: "VDPG", pct: 20,
    or: { fund: "Vanguard FTSE All-World (Acc)", ticker: "VWRP" },
    why: [
      "These are less concentrated in the US.",
      "If a US president, or anybody in the Western world, brings in new policies, these ETFs are less affected than the first one.",
    ],
  },
  {
    id: "gold", color: "var(--sp-s3)", role: "Hedge", name: "Gold",
    fund: "iShares Physical Gold ETC", ticker: "SGLN", pct: 20,
    why: [
      "Gold is used for hedging, particularly at a time like this.",
      "I keep a little bit of a commodity like gold to hedge against inflation, and to balance out the tech-driven and equity-driven ETFs above.",
    ],
  },
  {
    id: "bonds", color: "var(--sp-s4)", role: "Steady interest", name: "Government bonds",
    fund: "UK gilts (outside the UK: your local government bonds)", ticker: null, pct: 20,
    why: [
      "A bond is you lending money to the government. They pay you interest yearly or quarterly, depending on the bond.",
      "Pick the length by when you might need the money: 2, 5 or 10 years.",
    ],
    bond: true,
  },
  {
    id: "property", color: "var(--sp-s5)", role: "Defensive", name: "Real estate (REITs)",
    fund: "e.g. Realty Income Corp", ticker: "O", pct: 20,
    or: { fund: "if you have a mortgage, put this 20% towards an overpayment", ticker: null },
    why: [
      "A REIT is a Real Estate Investment Trust: you own a slice of property that pays you income.",
      "If you already own property and don't want more real estate, I'd pick a consumer staples or healthcare ETF. These are the staples of daily life, so the portfolio stays defensive while still moving your money forward.",
    ],
  },
];

const INITIAL_QUESTIONS = [
  { id: "q1", q: "I only have £100. Can I still do this?", votes: 0, a: "Yes. Keep the same five parts and put £20 in each, or start with the first two and add the rest over the next months. Most platforms let you buy fractions of an ETF." },
  { id: "q2", q: "Where do I actually buy these?", votes: 0, a: "You need an investing platform with a Stocks & Shares ISA. I'll show which one I use and how I bought each fund, step by step, in the live Q&A." },
  { id: "q3", q: "What if I invest and the market drops?", votes: 0, a: "It will drop at some point. That's why this portfolio mixes shares with gold, bonds and property: they don't all fall together. I only invest money I won't need for at least 5 years." },
  { id: "q4", q: "Why not just put everything in the S&P 500?", votes: 0, a: "You could, and many people do. I want less dependence on the US and on tech, which is why only 20% goes there." },
];

const BLOCKERS = [
  "I don't know which platform to use",
  "I'm scared of losing money",
  "I'm not sure I have enough",
  "I want to understand more first",
  "Something else",
];

const PRIVACY = "I'll only use this to send you what you asked for.";

/* ------------------------------------------------------------------ */
/* Netlify Forms                                                       */
/* ------------------------------------------------------------------ */

// Sends a submission to Netlify Forms. Fails silently where Netlify isn't hosting the page.
function submit(formName, data) {
  try {
    const body = new URLSearchParams({ "form-name": formName, ...(data || {}) }).toString();
    return fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    }).catch(() => {});
  } catch (_) {
    return undefined;
  }
}

// ----------------------------------------------------------------------------
// Component
// ----------------------------------------------------------------------------

/**
 * @param {{ theme?: "light" | "dark" }} props
 *   Omit `theme` to follow the visitor's system setting.
 */
const SophiaPortfolioStorefrontPage = ({ theme }) => {
  const uid = useId();
  const id = (name) => `${uid}-${name}`;

  // Portfolio
  const [openWhy, setOpenWhy] = useState({});
  const [saved, setSaved] = useState(false);
  const [following, setFollowing] = useState(false);

  // Q&A (new questions stay at the top until the page is refreshed)
  const [questions, setQuestions] = useState(INITIAL_QUESTIONS);
  const [voted, setVoted] = useState({});
  const [newestId, setNewestId] = useState(null);
  const [question, setQuestion] = useState("");
  const askInputRef = useRef(null);

  // Sheet
  const [sheet, setSheet] = useState(null); // { view, blocker? }
  const [fields, setFields] = useState({});
  const [bought, setBought] = useState([]);
  const sheetRef = useRef(null);
  const lastFocus = useRef(null);
  const fieldRefs = useRef({});

  // Toast
  const [toastMsg, setToastMsg] = useState("");
  const toastTimer = useRef(null);

  const toast = useCallback((msg) => {
    setToastMsg(msg);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastMsg(""), 2600);
  }, []);
  useEffect(() => () => clearTimeout(toastTimer.current), []);

  // Analytics
  const viewed = useRef(false);
  useEffect(() => {
    if (viewed.current) return;
    viewed.current = true;
    analytics.track("storefront_with_creator_portfolio_viewed");
  }, []);

  /* ---------- Sheet open / close ---------- */
  const openSheet = (view, extra = {}) => {
    // Remember what opened the sheet (not a button inside it), so focus can return there.
    if (!sheet) lastFocus.current = document.activeElement;
    setFields({});
    setBought([]);
    setSheet({ view, ...extra });
  };

  const closeSheet = useCallback(() => {
    setSheet(null);
    const el = lastFocus.current;
    if (el && typeof el.focus === "function") el.focus();
  }, []);

  // Focus the first field (or first non-close button) whenever the sheet's view changes.
  useEffect(() => {
    if (!sheet || !sheetRef.current) return;
    const first = sheetRef.current.querySelector("input, textarea, button:not(.sp-x)");
    if (first) first.focus();
  }, [sheet]);

  // Escape closes the sheet.
  useEffect(() => {
    if (!sheet) return undefined;
    const onKey = (ev) => { if (ev.key === "Escape") closeSheet(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [sheet, closeSheet]);

  /* ---------- Field helpers ---------- */
  const setField = (name) => (ev) => setFields((f) => ({ ...f, [name]: ev.target.value }));
  const val = (name) => (fields[name] || "").trim();
  const need = (name) => {
    const v = val(name);
    if (!v) {
      fieldRefs.current[name]?.focus();
      toast("Add an email or WhatsApp number first");
      return null;
    }
    return v;
  };
  const fieldRef = (name) => (el) => { fieldRefs.current[name] = el; };

  // Render helpers (plain functions, not components, so inputs keep focus while typing)
  const head = (title, sub) => (
    <div className="sp-sheet-head">
      <div>
        <h2 className="sp-h2" id={id("sheetTitle")}>{title}</h2>
        {sub && <p className="sp-text sp-muted sp-small sp-mt-4">{sub}</p>}
      </div>
      <button type="button" className="sp-button sp-x" aria-label="Close" onClick={closeSheet}>×</button>
    </div>
  );

  const contactField = (name, label) => (
    <div className="sp-field">
      <label className="sp-field-label" htmlFor={id(name)}>{label}</label>
      <input
        id={id(name)}
        ref={fieldRef(name)}
        className="sp-input sp-field-input"
        type="text"
        autoComplete="email"
        placeholder="Email or WhatsApp number"
        value={fields[name] || ""}
        onChange={setField(name)}
      />
    </div>
  );

  const privacy = <p className="sp-privacy">{PRIVACY}</p>;

  /* ---------- Actions ---------- */
  const toggleWhy = (sid) => setOpenWhy((o) => ({ ...o, [sid]: !o[sid] }));

  const toggleVote = (qid) => {
    const nowVoted = !voted[qid];
    setVoted((v) => ({ ...v, [qid]: nowVoted }));
    setQuestions((qs) => qs.map((q) => (q.id === qid ? { ...q, votes: q.votes + (nowVoted ? 1 : -1) } : q)));
    setNewestId(null);
  };

  const onAsk = (ev) => {
    ev.preventDefault();
    const text = question.trim();
    if (!text) { askInputRef.current?.focus(); return; }
    const qid = `u${Date.now()}`;
    setQuestions((qs) => [{ id: qid, q: text, votes: 1, a: null, mine: true }, ...qs]);
    setVoted((v) => ({ ...v, [qid]: true }));
    setNewestId(qid);
    submit("question", { question: text });
    setQuestion("");
    toast("Question posted");
  };

  const onFollowClick = () => {
    if (following) { toast("You're already following Sophia"); return; }
    openSheet("follow");
  };

  const onShare = () => {
    const url = window.location.href.split("#")[0];
    if (navigator.share) { navigator.share({ title: "Sophia's starter portfolio", url }).catch(() => {}); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        () => toast("Link copied"),
        () => toast("Copy the link from your address bar"),
      );
    } else {
      toast("Copy the link from your address bar");
    }
  };

  const sendSteps = () => {
    const v = need("sendTo"); if (!v) return;
    submit("start-steps", { contact: v });
    closeSheet(); toast("Sent. I'll check in with you in a week.");
  };

  const chooseBlocker = (label) => {
    submit("blocker", { blocker: label });
    openSheet("blockerNext", { blocker: label });
  };

  const rsvpFromBlocker = () => {
    const v = need("rsvpContact"); if (!v) return;
    submit("blocker", { blocker: sheet.blocker, detail: val("blockDetail"), contact: v });
    submit("live-rsvp", { contact: v, source: "blocker" });
    closeSheet(); toast(`Seat saved for ${LIVE.medium}`);
  };

  const rsvpOnly = () => {
    const v = need("rsvpOnly"); if (!v) return;
    submit("live-rsvp", { contact: v, source: "community" });
    closeSheet(); toast(`Seat saved for ${LIVE.medium}`);
  };

  const followSubmit = () => {
    const v = need("followContact"); if (!v) return;
    submit("follow", { contact: v });
    setFollowing(true);
    closeSheet(); toast("You're following Sophia");
  };

  const circleSubmit = () => {
    const v = need("circleContact"); if (!v) return;
    submit("circle-waitlist", { contact: v });
    closeSheet(); toast("You're on the waitlist");
  };

  const saveSubmit = () => {
    const v = need("saveContact"); if (!v) return;
    submit("save-portfolio", { contact: v, payday: val("payday") });
    setSaved(true);
    closeSheet(); toast("Portfolio saved. I'll be in touch.");
  };

  const boughtSubmit = () => {
    submit("first-investment", { bought: bought.join(", "), amount: val("amountIn") });
    openSheet("bought");
  };

  const toggleBought = (name) => (ev) => {
    const checked = ev.target.checked;
    setBought((b) => (checked ? [...b, name] : b.filter((x) => x !== name)));
  };

  /* ---------- Sheet views ---------- */
  const renderSheet = () => {
    switch (sheet.view) {
      case "start":
        return (
          <>
            {head("Where are you right now?", "Pick the one closest to you.")}
            <div className="sp-options">
              <button type="button" className="sp-button sp-option" onClick={() => openSheet("ready")}>
                <b className="sp-option-title">I'm ready. Show me how to buy it.</b>
                <span className="sp-option-desc">The exact steps I followed</span>
              </button>
              <button type="button" className="sp-button sp-option" onClick={() => openSheet("blocked")}>
                <b className="sp-option-title">Not yet. Something's stopping me.</b>
                <span className="sp-option-desc">Tell me what, and I'll answer it</span>
              </button>
              <button type="button" className="sp-button sp-option" onClick={() => openSheet("done")}>
                <b className="sp-option-title">I've already bought some of this</b>
                <span className="sp-option-desc">Tell me what you bought</span>
              </button>
            </div>
          </>
        );

      case "ready":
        return (
          <>
            {head("How I'd buy this, step by step")}
            <ol className="sp-steps">
              <li><b>Pick a platform</b> that offers a Stocks &amp; Shares ISA.</li>
              <li><b>Open your ISA.</b> Have your National Insurance number and bank details ready (about 10 minutes).</li>
              <li><b>Add money</b>: whatever you're comfortable starting with.</li>
              <li><b>Split it 20% into each of the five parts:</b> VUAG, VDPG or VWRP, SGLN, a UK gilt, and a REIT or your mortgage overpayment.</li>
            </ol>
            {contactField("sendTo", "Send me these steps, and check in with me in a week")}
            {privacy}
            <div className="sp-btn-row">
              <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={sendSteps}>Send me the steps</button>
              <button type="button" className="sp-button sp-btn sp-btn-ghost" onClick={() => openSheet("done")}>I've done it</button>
            </div>
          </>
        );

      case "blocked":
        return (
          <>
            {head("What's stopping you?", "Your answer helps me decide what to cover in the live Q&A.")}
            <div className="sp-options">
              {BLOCKERS.map((label) => (
                <button key={label} type="button" className="sp-button sp-option" onClick={() => chooseBlocker(label)}>
                  <b className="sp-option-title">{label}</b>
                </button>
              ))}
            </div>
          </>
        );

      case "blockerNext":
        return (
          <>
            {head("Thanks, that's really common.", `Bring it to the live Q&A on ${LIVE.medium}, and I'll answer it there.`)}
            <div className="sp-field">
              <label className="sp-field-label" htmlFor={id("blockDetail")}>Anything you'd like me to know? (optional)</label>
              <textarea
                id={id("blockDetail")}
                className="sp-input sp-field-input"
                rows={3}
                value={fields.blockDetail || ""}
                onChange={setField("blockDetail")}
              />
            </div>
            {contactField("rsvpContact", "Where should I send the Zoom link?")}
            {privacy}
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={rsvpFromBlocker}>Save my seat</button>
          </>
        );

      case "done":
        return (
          <>
            {head("Amazing. What did you buy?", "Tick everything you bought. This helps other beginners see it's possible.")}
            <div className="sp-options sp-options-loose">
              {SLICES.map((s) => (
                <label key={s.id} className="sp-check">
                  <input
                    type="checkbox"
                    className="sp-checkbox"
                    value={s.name}
                    checked={bought.includes(s.name)}
                    onChange={toggleBought(s.name)}
                  />{" "}
                  {s.name}
                </label>
              ))}
            </div>
            <div className="sp-field">
              <label className="sp-field-label" htmlFor={id("amountIn")}>Roughly how much did you invest?</label>
              <input
                id={id("amountIn")}
                className="sp-input sp-field-input"
                type="text"
                inputMode="decimal"
                placeholder="e.g. £200"
                value={fields.amountIn || ""}
                onChange={setField("amountIn")}
              />
            </div>
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={boughtSubmit}>Share my first investment</button>
          </>
        );

      case "bought":
        return (
          <>
            {head("You're an investor now.")}
            <p className="sp-text">That's the hardest step done. Most people never take it.</p>
            <p className="sp-text sp-muted sp-small">Want to keep going? Add a little each month and the portfolio does the rest.</p>
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={closeSheet}>Done</button>
          </>
        );

      case "save":
        return (
          <>
            {head("Save my starter portfolio", "I'll send you the portfolio, and one reminder on your next payday.")}
            {contactField("saveContact", "Email or WhatsApp number")}
            <div className="sp-field">
              <label className="sp-field-label" htmlFor={id("payday")}>When's your payday? (optional)</label>
              <input
                id={id("payday")}
                className="sp-input sp-field-input"
                type="text"
                placeholder="e.g. 28th of the month"
                value={fields.payday || ""}
                onChange={setField("payday")}
              />
            </div>
            {privacy}
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={saveSubmit}>Save portfolio</button>
          </>
        );

      case "rsvp":
        return (
          <>
            {head(`Live Q&A · ${LIVE.short}`, "30 minutes on Zoom. Bring your question.")}
            {contactField("rsvpOnly", "Where should I send the link?")}
            {privacy}
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={rsvpOnly}>Save my seat</button>
          </>
        );

      case "follow":
        return (
          <>
            {head("Follow Sophia", "Get my portfolio update each month: what I bought, and why.")}
            {contactField("followContact", "Email or WhatsApp number")}
            {privacy}
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={followSubmit}>Follow</button>
          </>
        );

      case "circle":
        return (
          <>
            {head("Monthly Wealth Circle", "A live group call each month, £9/month. Join the waitlist and I'll message you when it opens.")}
            {contactField("circleContact", "Email or WhatsApp number")}
            {privacy}
            <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={circleSubmit}>Join the waitlist</button>
          </>
        );

      default:
        return null;
    }
  };

  /* ---------- Page ---------- */
  return (
    <div className="sp-root" data-theme={theme}>
      <div className="sp-wrap">
        <div className="sp-grid">

          <aside className="sp-side">
            <section className="sp-card sp-stack sp-order-profile" aria-label="About Sophia">
              <div className="sp-profile-top">
                <img className="sp-avatar" src={AVATAR_SRC} alt="Sophia" width={64} height={64} />
                <div>
                  <h1 className="sp-h1">Sophia</h1>
                  <div className="sp-handle">Modern Wealth · London</div>
                </div>
              </div>
              <p className="sp-text">I show you exactly what I'd buy, and why, so you can stop researching and make your first investment.</p>
              <div className="sp-stats sp-tnum"><span><b className="sp-stats-num">10K+</b> followers on RedNote</span></div>
              <div className="sp-btn-row">
                <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={onFollowClick}>
                  {following ? "Following" : "Follow"}
                </button>
                <button type="button" className="sp-button sp-btn sp-btn-ghost" onClick={onShare}>Share</button>
              </div>
            </section>

            <section className="sp-card sp-stack sp-order-trust" aria-labelledby={id("whyme")}>
              <h3 className="sp-h3" id={id("whyme")}>Why listen to me</h3>
              <ul className="sp-list sp-creds">
                <li className="sp-cred"><span>London-based, investing since 2019</span></li>
                <li className="sp-cred"><span>Founder &amp; CEO @ WInvest Collective</span></li>
                <li className="sp-cred"><span>Forbes 30 Under 30, Finance Europe</span></li>
                <li className="sp-cred"><span>Innovate UK Next Gen Fintech Award recipient</span></li>
                <li className="sp-cred"><span>I hold everything I show here. No fund pays me to feature it.</span></li>
              </ul>
            </section>

            <section className="sp-card sp-stack sp-order-learn" aria-labelledby={id("learn")}>
              <h3 className="sp-h3" id={id("learn")}>Learn with me</h3>
              <div className="sp-products">
                <a
                  className="sp-link sp-product"
                  href="https://www.udemy.com/course/investing-basics-for-gen-z-millennials/?referralCode=CC4582508CCBC7578490"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sp-picon" aria-hidden="true">
                    <svg className="sp-picon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H11v15H5.5A1.5 1.5 0 0 1 4 17.5z" />
                      <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H13v15h5.5a1.5 1.5 0 0 0 1.5-1.5z" />
                    </svg>
                  </span>
                  <span>
                    <span className="sp-ptitle">Investing Basics for Gen Z &amp; Millennials</span><br />
                    <span className="sp-pmeta">Online course · Udemy<span className="sp-tag">Affiliate</span></span>
                  </span>
                  <span className="sp-price">View</span>
                </a>
                <button type="button" className="sp-button sp-product sp-product-button" onClick={() => openSheet("circle")}>
                  <span className="sp-picon" aria-hidden="true">
                    <svg className="sp-picon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <circle cx="9" cy="9" r="3" />
                      <circle cx="16" cy="10" r="2.5" />
                      <path d="M3.5 19c.8-3 3-4.5 5.5-4.5s4.7 1.5 5.5 4.5" />
                      <path d="M14.5 15c2.2-.3 4.5.8 5.5 4" />
                    </svg>
                  </span>
                  <span>
                    <span className="sp-ptitle">Monthly Wealth Circle</span><br />
                    <span className="sp-pmeta">Live group call each month · join the waitlist</span>
                  </span>
                  <span className="sp-price sp-tnum">£9/mo</span>
                </button>
              </div>
            </section>
          </aside>

          <main className="sp-main">
            <section className="sp-card sp-stack sp-order-plan" aria-labelledby={id("planTitle")}>
              <div className="sp-alloc-head">
                <div className="sp-donut" role="img" aria-label="Five equal slices of 20% each">
                  <div className="sp-donut-label">
                    <b className="sp-donut-value sp-tnum">100%</b>
                    <span className="sp-small sp-muted">5 × 20%</span>
                  </div>
                </div>
                <div className="sp-alloc-intro">
                  <span className="sp-eyebrow">Starter portfolio</span>
                  <h2 className="sp-h2" id={id("planTitle")}>If I were starting to invest today, this is how I'd split my money</h2>
                  <span className="sp-date">{UPDATED}</span>
                </div>
              </div>

              <ol className="sp-list sp-slices">
                {SLICES.map((s) => (
                  <li key={s.id} className="sp-slice">
                    <div className="sp-slice-row">
                      <span className="sp-dot" style={{ background: s.color }} aria-hidden="true" />
                      <div>
                        <div className="sp-slice-role">{s.role}</div>
                        <div className="sp-slice-name">{s.name}</div>
                        <div className="sp-fund">
                          {s.fund}
                          {s.ticker && <> <span className="sp-ticker">{s.ticker}</span></>}
                        </div>
                        {s.or && (
                          <div className="sp-or">
                            or {s.or.fund}
                            {s.or.ticker && <> <span className="sp-ticker">{s.or.ticker}</span></>}
                          </div>
                        )}
                        <button
                          type="button"
                          className="sp-button sp-why-toggle"
                          aria-expanded={!!openWhy[s.id]}
                          onClick={() => toggleWhy(s.id)}
                        >
                          {openWhy[s.id] ? "Hide why" : "Why I chose this"}
                        </button>
                      </div>
                      <div className="sp-amount sp-tnum">
                        <b className="sp-amount-value">{s.pct}%</b>
                        <div className="sp-amount-label">of portfolio</div>
                      </div>
                    </div>
                    {openWhy[s.id] && (
                      <div className="sp-why">
                        {s.why.map((p) => <p key={p} className="sp-why-p">{p}</p>)}
                        {s.bond && (
                          <>
                            <div className="sp-bond sp-tnum" aria-label="Two-year bond example">
                              <div className="sp-bond-cell">You lend<b className="sp-bond-value">£80</b></div>
                              <div className="sp-bond-cell">Interest<b className="sp-bond-value">£5 × 2</b></div>
                              <div className="sp-bond-cell">At maturity<b className="sp-bond-value">£100</b></div>
                              <div className="sp-bond-cell">You get<b className="sp-bond-value">£110</b></div>
                            </div>
                            <p className="sp-text sp-small sp-muted sp-mt-6">Example 2-year bond: £30 profit on £80, a 37.5% return over two years.</p>
                          </>
                        )}
                      </div>
                    )}
                  </li>
                ))}
              </ol>

              <div className="sp-cta-box">
                <button type="button" className="sp-button sp-btn sp-btn-primary sp-btn-block" onClick={() => openSheet("start")}>
                  I want to start investing
                </button>
                <button type="button" className="sp-button sp-btn sp-btn-ghost sp-btn-block" onClick={() => openSheet("save")}>
                  {saved ? "Saved ✓" : "Save this portfolio"}
                </button>
                <p className="sp-disclaimer">
                  This is my personal allocation, shared for education. It isn't financial advice or a recommendation for you.
                  The value of investments can go down as well as up, and you may get back less than you put in.
                </p>
              </div>
            </section>

            <section className="sp-card sp-stack sp-order-community" aria-labelledby={id("commTitle")}>
              <div className="sp-section-head">
                <h2 className="sp-h2" id={id("commTitle")}>Ask me anything</h2>
                <span className="sp-small sp-muted">Questions from the community, answered by me</span>
              </div>

              <div className="sp-live">
                <div className="sp-live-text">
                  <span className="sp-live-badge">Live Q&amp;A</span>
                  <p className="sp-text"><b>{LIVE.full}</b> · 30 minutes on Zoom. I'll answer the most-asked questions below, live.</p>
                </div>
                <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={() => openSheet("rsvp")}>Save my seat</button>
              </div>

              <form className="sp-ask" onSubmit={onAsk}>
                <label htmlFor={id("askInput")} className="sp-eyebrow sp-ask-label">Your question</label>
                <input
                  id={id("askInput")}
                  ref={askInputRef}
                  className="sp-input sp-ask-input"
                  type="text"
                  placeholder="e.g. Can I start with just £100?"
                  autoComplete="off"
                  maxLength={280}
                  value={question}
                  onChange={(ev) => setQuestion(ev.target.value)}
                />
                <button type="submit" className="sp-button sp-btn sp-btn-primary">Ask</button>
              </form>

              <ul className="sp-list sp-qa">
                {questions.map((q) => (
                  <li key={q.id} className={`sp-qa-item${q.id === newestId ? " sp-is-new" : ""}`}>
                    <div>
                      {q.mine && <span className="sp-yours">Your question</span>}
                      <p className="sp-q">{q.q}</p>
                      {q.a
                        ? <p className="sp-a"><b className="sp-a-name">Sophia:</b> {q.a}</p>
                        : <p className="sp-a">Sophia will answer this in the live Q&amp;A.</p>}
                    </div>
                    <button
                      type="button"
                      className="sp-button sp-metoo sp-tnum"
                      aria-pressed={!!voted[q.id]}
                      onClick={() => toggleVote(q.id)}
                    >
                      {q.votes > 0 && <b className="sp-metoo-count">{q.votes}</b>}
                      Me too
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          </main>
        </div>
      </div>

      <footer className="sp-footer">Storefront powered by WInvest Collective</footer>

      <div className="sp-mobile-cta">
        <button type="button" className="sp-button sp-btn sp-btn-ghost sp-btn-fixed" onClick={() => openSheet("save")}>
          {saved ? "Saved ✓" : "Save"}
        </button>
        <button type="button" className="sp-button sp-btn sp-btn-primary" onClick={() => openSheet("start")}>
          I want to start investing
        </button>
      </div>

      {sheet && (
        <div className="sp-overlay" onClick={(ev) => { if (ev.target === ev.currentTarget) closeSheet(); }}>
          <div className="sp-sheet" role="dialog" aria-modal="true" aria-labelledby={id("sheetTitle")} ref={sheetRef}>
            {renderSheet()}
          </div>
        </div>
      )}

      <div className="sp-toast" role="status" hidden={!toastMsg}>{toastMsg}</div>
    </div>
  );
};

export default SophiaPortfolioStorefrontPage;
